import React from 'react';
import Icon from '../../../components/AppIcon';

const UploadConfirmationBanner = ({ uploadedDocument }) => {
  if (!uploadedDocument) return null;

  return (
    <section className="py-8 bg-gradient-to-br from-success/10 via-success/5 to-background border-y-2 border-success/30">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-2xl shadow-2xl border-2 border-success p-6 md:p-8">
          {/* Header with Icon */}
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="w-16 h-16 rounded-full bg-gradient-to-br from-success to-success/80 flex items-center justify-center shadow-lg">
              <Icon name="CheckCircle2" size={36} color="white" />
            </div>
            <div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-success">
                Erfolgreich gespeichert!
              </h2>
              <p className="text-sm text-muted-foreground mt-1">
                Ihre Fahrzeugdaten wurden übermittelt
              </p>
            </div>
          </div>

          {/* Confirmation Cards */}
          <div className="grid md:grid-cols-2 gap-4 mb-6">
            {/* Fahrzeugschein Card */}
            <div className="bg-gradient-to-br from-success/10 to-success/5 rounded-xl p-5 border-2 border-success/40">
              <div className="flex items-start gap-3">
                <div className="w-12 h-12 rounded-full bg-success flex items-center justify-center flex-shrink-0">
                  <Icon name="FileCheck" size={24} color="white" />
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <h3 className="font-bold text-foreground text-lg">Fahrzeugschein</h3>
                    <div className="px-2 py-0.5 bg-success rounded-full">
                      <span className="text-xs font-bold text-white">✓ HOCHGELADEN</span>
                    </div>
                  </div>
                  <p className="text-sm text-muted-foreground">
                    Ihr Fahrzeugschein wurde erfolgreich hochgeladen und gespeichert.
                  </p>
                </div>
              </div>
            </div>

            {/* FIN Card */}
            <div className="bg-gradient-to-br from-primary/10 to-primary/5 rounded-xl p-5 border-2 border-primary/40">
              <div className="flex items-start gap-3">
                <div className="w-12 h-12 rounded-full bg-primary flex items-center justify-center flex-shrink-0">
                  <Icon name="Hash" size={24} color="white" />
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <h3 className="font-bold text-foreground text-lg">FIN eingetragen</h3>
                    <div className="px-2 py-0.5 bg-primary rounded-full">
                      <span className="text-xs font-bold text-white">✓ ERFASST</span>
                    </div>
                  </div>
                  <p className="text-sm text-muted-foreground mb-2">
                    Fahrgestellnummer erfolgreich erfasst
                  </p>
                  <div className="bg-white/80 rounded-lg px-3 py-2 border border-primary/20">
                    <p className="text-xs text-muted-foreground mb-1">FIN:</p>
                    <p className="font-mono font-bold text-foreground text-sm">
                      {uploadedDocument?.chassisNumber}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Vehicle Model Info */}
          {uploadedDocument?.vehicleModel && (
            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-4 border border-blue-200 mb-6">
              <div className="flex items-center gap-3">
                <Icon name="Car" size={24} color="#3b82f6" />
                <div>
                  <p className="text-xs text-muted-foreground">Fahrzeugmodell:</p>
                  <p className="font-bold text-foreground">{uploadedDocument?.vehicleModel}</p>
                </div>
              </div>
            </div>
          )}

          {/* Security Notice */}
          <div className="bg-gradient-to-r from-green-600 to-emerald-600 rounded-xl p-4 shadow-lg">
            <div className="flex items-start gap-3">
              <Icon name="ShieldCheck" size={24} color="white" className="flex-shrink-0 mt-0.5" />
              <div>
                <p className="font-bold text-white mb-1">
                  Ihre Daten sind sicher gespeichert
                </p>
                <p className="text-sm text-white/90">
                  Der Fahrzeugschein und die Fahrgestellnummer (FIN) wurden erfolgreich übermittelt und werden bei der Antragstellung automatisch verwendet.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UploadConfirmationBanner;